import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const UserAgreementModal = ({ show, onAccept, onDecline }) => {
  return (
    <Modal show={show} onHide={onDecline} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>User Agreement & Terms of Service</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <div className="mb-4">
          <h5>1. Acceptance of Terms</h5>
          <p>
            By creating an account with PulseSync, you agree to be bound by these Terms of Service 
            and all applicable laws and regulations. If you do not agree with any of these terms, 
            you are prohibited from using or accessing this service.
          </p>
        </div>

        <div className="mb-4">
          <h5>2. Description of Service</h5>
          <p>
            PulseSync is a web-based application that provides subscription-based services. 
            The service includes user management, support ticket systems, and premium features 
            accessible through paid subscriptions.
          </p>
        </div>

        <div className="mb-4">
          <h5>3. User Accounts</h5>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials 
            and for all activities that occur under your account. You agree to notify us immediately 
            of any unauthorized use of your account.
          </p>
        </div>

        <div className="mb-4">
          <h5>4. Subscription and Billing</h5>
          <p>
            PulseSync offers subscription-based services. By subscribing, you agree to pay all 
            applicable fees and charges. Subscriptions are billed in advance and are non-refundable 
            except as required by law. You may cancel your subscription at any time through your 
            account settings.
          </p>
        </div>

        <div className="mb-4">
          <h5>5. Privacy Policy</h5>
          <p>
            Your privacy is important to us. We collect and use your information in accordance 
            with our Privacy Policy. By using our service, you consent to the collection and use 
            of information as described in our Privacy Policy.
          </p>
        </div>

        <div className="mb-4">
          <h5>6. Prohibited Uses</h5>
          <p>
            You may not use our service for any unlawful purpose or to solicit others to perform 
            unlawful acts. You may not violate any international, federal, provincial, or state 
            regulations, rules, laws, or local ordinances.
          </p>
        </div>

        <div className="mb-4">
          <h5>7. Intellectual Property</h5>
          <p>
            The service and its original content, features, and functionality are and will remain 
            the exclusive property of PulseSync and its licensors. The service is protected by 
            copyright, trademark, and other laws.
          </p>
        </div>

        <div className="mb-4">
          <h5>8. Termination</h5>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability, 
            for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
        </div>

        <div className="mb-4">
          <h5>9. Disclaimer</h5>
          <p>
            The information on this service is provided on an "as is" basis. To the fullest extent 
            permitted by law, this Company excludes all representations, warranties, conditions and 
            terms relating to our service and the use of this service.
          </p>
        </div>

        <div className="mb-4">
          <h5>10. Contact Information</h5>
          <p>
            If you have any questions about these Terms of Service, please contact us at 
            support@pulsesync.com.
          </p>
        </div>

        <div className="alert alert-info">
          <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onDecline}>
          Decline
        </Button>
        <Button variant="primary" onClick={onAccept}>
          I Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserAgreementModal;
